import { useState } from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import Form from 'react-bootstrap/Form';
import { exportReportFile } from '../../../../utils/reports';
import { useReportDimensions } from '../../../../hooks/useReportDimensions';
import ReportActionRow from '../ReportActionRow';
import AggregatorMonthlyDoc from '../pdf-documents/AggregatorMonthlyDoc/AggregatorMonthlyDoc';

function ReportAggregatorMonthly({
  reportTitle,
  reportDetails,
  reportId,
  setSpinner,
  reportType,
  report,
}) {
  const [activeItem, setActiveItem] = useState(report[0]);

  const { height, width } = useReportDimensions();

  const exportFile = async () => {
    setSpinner(true);

    try {
      await exportReportFile({ reportType, report });
    } catch (err) {
      console.error(err);
    } finally {
      setSpinner(false);
    }
  };

  return (
    <>
      <ReportActionRow
        reportTitle={reportTitle}
        reportDetails={reportDetails}
        reportId={reportId}
        setSpinner={setSpinner}
        renderSelect={() =>
          report.length > 1 ? (
            <Form.Select
              className="bo-filter bo-w-250 mb-2"
              value={activeItem.aggregatorId}
              onChange={e =>
                setActiveItem(report.find(x => x?.aggregatorId === Number(e.target.value)))
              }
            >
              {report.map(agg => (
                <option key={agg.aggregatorId} value={agg.aggregatorId}>
                  {agg.aggregatorName}
                </option>
              ))}
            </Form.Select>
          ) : null
        }
        exportFile={exportFile}
      />
      <PDFViewer width={width} height={height} showToolbar={false} key={activeItem.aggregatorId}>
        <AggregatorMonthlyDoc item={activeItem} />
      </PDFViewer>
    </>
  );
}

export default ReportAggregatorMonthly;
